<template>
  <div class="videoCard-container">
    <div class="videoCard-fake-button" @click.prevent="videoClickedHandler" v-if="videoCard.image==''"></div>
    <img ref="image" class="videoCard-image" :src="videoCard.image" v-if="videoCard.image!=''"/>
    <iframe class="videoCard-video" id="iframe" :src="videoCard.video" frameborder="0" allow="autoplay; encrypted-media;" allowfullscreen v-if="videoCard.image==''"></iframe>
    <div class="videoCard-details">
      <div class="videoCard-title-and-download-container">
        <h3 class="videoCard-title" v-html="videoCard.title"></h3>
        <ion-icon class="videoCard-download-btn" name="cloud-download-outline" @click.prevent="downloadMaterialHandler" v-if="videoCard.downloadUrl!=''"></ion-icon>
      </div>
      <p class="videoCard-description" v-html="videoCard.description"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCard',
  props: ['videoCard', 'imageStyle', 'videoCardDetailsStyle', 'roleStyle', 'descriptionStyle'],
  data() {
    return {};
  },
  methods: {
    videoClickedHandler(event) {
      this.$emit('videoClicked', 'someValue');
    },

    downloadMaterialHandler() {
      this.$emit('downloadMaterialClicked', 'someValue');
      fetch(this.videoCard.downloadUrl, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      })
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = 'material';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.warn(err));
    }
  },
};
</script>

<style lang="scss">
p {
  overflow-y: hidden; // in case we get more text than fits the videoCard
}
.videoCard-fake-button {
  cursor: pointer;
  position: absolute;
  background-color: transparent;
  width: 300px;
  height: 130px;
  z-index: 10;
  &:hover {
    transform: scale(1.25);
  }
}
.videoCard-container {
  position: relative;
  width: 240px;
  height: 260px;
  margin: 1%;
  justify-self: flex-start;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  box-shadow: 0 0.2rem 1.5rem shadow;
  overflow: hidden;
  transition: 0.3s;
  z-index: 1;

  &:hover {
    transform: scale(1.25);
    transition: 0.3s;
    z-index: 10;
  }
}
.videoCard-image {
  position: relative;
  width: auto;
  height: 50%;
  border-radius: var(--input-borderRadius);
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
  object-fit: cover;
  object-position: top;
}
.videoCard-video {
  position: relative;
  width: auto;
  height: 50%;
  border-radius: var(--input-borderRadius);
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
}
.videoCard-details {
  position: relative;
  padding: 3% 5% 2% 5%;
  // height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.videoCard-title-and-download-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}
.videoCard-title {
  position: relative;
  width: 88%;
  font-size: 1.4rem;
  // line-height: 1.4;
  color: var(--secondary-color);
  font-weight: 700;
  // margin-bottom: auto;
}
.videoCard-download-btn {
  position: relative;
  cursor: pointer;
  font-size: 1.5rem;
  color: var(--secondary-color);
}
.videoCard-description {
  position: relative;
  color: var(--text-color);
  font-size: 0.9rem;
  height: 10vh;
  flex-grow: 1;
  margin: 6px 0;
  padding-right: 6px;
  overflow-y: auto;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>